/**
 * フロートボタンの表示/非表示を制御
 * 「来店予約・店舗一覧」セクションより上では表示、下では非表示
 */
function initFloatButton(): void {
  const floatButton = document.querySelector<HTMLElement>('.js-float-btn');
  const accordionWrapper = document.querySelector<HTMLElement>('.c-accordion__wrapper');
  const reserveInner = document.querySelector<HTMLElement>('.c-reserve__inner');

  if (!floatButton || !accordionWrapper || !reserveInner) return;

  /**
   * スクロール位置に応じてフロートボタンの表示/非表示を切り替え
   */
  const updateFloatButtonVisibility = (): void => {
    const accordionTop = accordionWrapper.getBoundingClientRect().top;
    const reserveInnerTop = reserveInner.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    // c-accordion__wrapper が画面内に入ったら表示開始、c-reserve__inner が入ったら非表示
    const shouldShow = accordionTop <= windowHeight && reserveInnerTop > windowHeight;
    if (!shouldShow) {
      floatButton.classList.add('is-hidden');
    } else {
      floatButton.classList.remove('is-hidden');
    }
  };

  // スクロールイベントにリスナーを登録（パフォーマンス最適化のためpassiveオプションを使用）
  window.addEventListener('scroll', updateFloatButtonVisibility, { passive: true });

  // リサイズ時も更新
  window.addEventListener('resize', updateFloatButtonVisibility, { passive: true });

  // 初期化時に一度実行
  updateFloatButtonVisibility();
}

export { initFloatButton };
